import { ApolloError } from '@apollo/client'

function IsJsonString(str?: string) {
  if (str === undefined) return false
  try {
    JSON.parse(str)
  } catch {
    return false
  }
  return true
}
export function parseGraphQLErrorMessage(
  error: ApolloError | Error,
  type?: string
) {
  let errorMessage: string | null | undefined
  if (error?.toString) {
    errorMessage = error.toString().replace('Error: GraphQL error: ', '')
    errorMessage = errorMessage.toString().replace('400 - ', '')
    errorMessage = errorMessage.toString().replace('401 - ', '')
  }

  // If the error message is a valid JSON then, retrieve the error message from the object
  if (
    errorMessage !== undefined &&
    errorMessage !== null &&
    IsJsonString(errorMessage)
  ) {
    const errorObj = JSON.parse(errorMessage)
    errorMessage = errorObj.error.message
  }

  if (type !== undefined && type !== '') {
    errorMessage = 'City or State is missing, please enter valid address.'
  }

  // If the message contains network error
  if (errorMessage?.toLowerCase().indexOf('network error') !== -1) {
    // errorMessage = errorMessage.toString().replace('Error: Network error: ', '');
    // Error: Network error: Response not successful: Received status code 400
    errorMessage = 'An error occurred please try again later.'
  }

  if ('graphQLErrors' in error) {
    errorMessage = error?.graphQLErrors?.[0]?.message || errorMessage
  }

  if (errorMessage === undefined || errorMessage === null) {
    errorMessage = 'Oh no! An error occurred. Please try again.'
  }

  if (errorMessage === 'Internal server error') {
    errorMessage = 'Service is temporarily unavailable'
  }

  return errorMessage
}
